export function isEditRoute(uri: string) {
	return uri.includes('/edit-v2/');
}

export function parseDraftId(query: { [key: string]: any }) {
	const draftShareId = query?.draftShareId;
	return Array.isArray(draftShareId) ? draftShareId?.[0] : draftShareId;
}
